import request from '@/utils/request';


// 登录接口
export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data
  })
}

//组件产品

/**
 * 获取可选择的支架型号列表
 * @export
 * @returns {*}
 */
export function getSelectableBracketModels () {
  return request({
    url: '/support/getHouseSelect',
    method: 'get',
  })
}

export function ComponentProduct(data) {
    return request({
        url: "/cal-out-user/componentSpecification",
        method: "post",
        data,
    });
}
//组件产品 - list
export function ComponentProductList(data) {
    return request({
        url: "/cal-out-user/seletOne",
        method: "post",
        data,
    });
}
//省份
export function ProvinceData(data) {
    return request({
        url: "/cal-out-user/province",
        method: "post",
        data,
    });
}
//城市
export function CityData(data) {
    return request({
        url: "/cal-out-user/city",
        method: "post",
        data,
    });
}
//户用测算
export function ListResult(data) {
    return request({
        url: "/cal-out-user/result",
        method: "post",
        data,
    });
}

///分布式商用
//组件产品
export function CommercialProduct(data) {
    return request({
        url: "/cal-out-bus/componentSpecification",
        method: "post",
        data,
    });
}
//组件产品 - list
export function CommercialProductList(data) {
    return request({
        url: "/cal-out-bus/seletOne",
        method: "post",
        data,
    });
}
//省份
export function CommercialProvince(data) {
    return request({
        url: "/cal-out-bus/province",
        method: "post",
        data,
    });
}
//城市
export function CommercialCity(data) {
    return request({
        url: "/cal-out-bus/city",
        method: "post",
        data,
    });
}
//计算
export function CommercialResult(data) {
    return request({
        url: "/cal-out-bus/result",
        method: "post",
        data,
    });
}



///留言
export function SubmitMessage(data) {
    return request({
        url: "/cal-out-bus/message",
        method: "post",
        data,
    });
}

/**
 * 获取语言类型
 * @export
 * @returns {*}
 */
export function getLanguageList () {
  return request({
    url: '/language/list',
    method: 'get',
  })
}


/**
 * 获取语言翻译字典
 * @export
 * @returns {*}
 */
export function getLanguageTranslateList () {
  return request({
    url: '/translations/query',
    method: 'get',
  })
}


/**
 * 户用：计算最佳倾角
 * @param {*} data
 * @returns {*}
 */
export function calUserDipBest (data) {
  return request({
    url: '/cal-out-user/dipBest',
    method: 'post',
    data,
  })
}


/**
 * 商用：计算最佳倾角
 * @param {*} data
 * @returns {*}
 */
export function calBusDipBest (data) {
  return request({
    url: '/cal-out-bus/dipBest',
    method: 'post',
    data
  })
}


/**
 * 获取组件名称
 * @param useType cal-out-bus商用 / cal-out-user户用 /component-config设备选型
 * @returns {*}
 */
export function getComponentSpecification (useType = '', data = {}) {
  return request({
    url: `/${useType}/componentSpecification`,
    method: 'post',
    data
  })
}

/**
 * 获取组件功率
 * @param useType cal-out-bus商用 / cal-out-user户用 /component-config设备选型
 * @returns {*}
 */
export function getComponentPower (useType = '', data = {}) {
  return request({
    url: `/${useType}/componentPower`,
    method: 'post',
    data
  })
}
